/* global G */
import { modelComposition } from 'trait/composition'
import { pipe } from 'lib/util'
import { usesGetterSetter } from 'trait/uses'
import toRef from 'model/_shared/transformer/toRef'
import fromTimestamp from 'model/_shared/decorator/fromTimestamp'
import { withGetterSetter } from 'trait/with'

const descriptor = 'model::xEcoApm::sensor'

export default pipe(
  modelComposition(descriptor),
  withGetterSetter(G.DECORATOR),
  usesGetterSetter(G.DECORATOR, {
    licensedUntil: fromTimestamp('short', 'licensedUntil'),
  }),
  usesGetterSetter(G.TRANSFORMER, {
    submitter: toRef('submitter'),
    registeredFor: toRef('registeredFor'),
  }),
)
